import React, { useEffect, useMemo } from 'react';
import './ProgressBar.css';
import { useProductWeightsPreOrders } from '../../libraries/hooks/useProductWeightsPreOrders';
import soccerball from '../../images/WK_voetbal.png';
import { getLocale } from '../../libraries/i18n';

export const KG_PER_REWARD = 40;
export const BALLS_PER_STEP = 10;

export const calculateFreeBalls = (currentWeight: number) => {
	const steps = Math.floor(currentWeight / KG_PER_REWARD);
	return steps * BALLS_PER_STEP;
};
const ProgressBar = () => {
			 const currentWeight = useProductWeightsPreOrders();
			 const balls = calculateFreeBalls(currentWeight);
			 const steps = balls / BALLS_PER_STEP;
			 const nextThreshold = (steps + 1) * KG_PER_REWARD;
			 const remainingKg = Math.max(nextThreshold - currentWeight, 0).toFixed(2);
			 type Locale = 'nl' | 'fr';
			 let locale: Locale;
			 try {
				 const l = getLocale();
				 locale = l === 'fr' ? 'fr' : 'nl';
			 } catch {
				 locale = 'nl';
			 }

			 // Teksten voor beide talen
			 const TEXT: Record<Locale, {
				 krijgt: string;
				 gratis: string;
				 ballen: string;
				 nog: string;
				 teGaan: string;
				 meerBallen: string;
				 reward: string;
			 }> = {
				 nl: {
					 krijgt: 'U krijgt',
					 gratis: 'gratis',
					 ballen: 'wk-voetballen!',
					 nog: 'Nog',
					 teGaan: 'te gaan voor',
					 meerBallen: `+${BALLS_PER_STEP} gratis`,
					 reward: 'wk-voetballen! ⚽',
				 },
				 fr: {
					 krijgt: 'Vous recevez',
					 gratis: 'gratuits',
					 ballen: 'ballons de la coupe du monde!',
					 nog: 'Encore',
					 teGaan: 'à parcourir pour',
					 meerBallen: `+${BALLS_PER_STEP} gratuits`,
					 reward: 'ballons coupe du monde! ⚽',
				 },
			 };
			 const t = TEXT[locale];

			 const minWeight = currentWeight <= 200 ? 0 : currentWeight - (currentWeight % 40) - 160;
			 const maxWeight = currentWeight <= 200 ? 200 : currentWeight - (currentWeight % 40) + 40;
			 const range = maxWeight - minWeight;

			 // Bepaal waar je zit in de progress bar (in %)
			 const clampedWeight = Math.min(Math.max(currentWeight, minWeight), maxWeight);
			 const progress = ((clampedWeight - minWeight) / range) * 100;
			 const progressCapped = currentWeight>=(0.95*5*40);

			 const milestones = useMemo(() => {
			 	const base = Math.max((currentWeight - (currentWeight % 40 ))/40 + 2, 7); // mss 2 /6
			 	const _milestones = new Array(base).fill('M')?.map((m, i) => i*40);
			 	return _milestones;
			 }, [currentWeight]);

			 const hideLabels = () => {
			 	const area = document.getElementsByClassName('progress-container')[0];
			 	const labels = area?.getElementsByClassName('milestone');
			 	// for (const label of labels) {
			 	// 	const textLabel = label.getElementsByTagName('span')[0];const { left: areaLeft, right: areaRight } = area.getBoundingClientRect();const { left: labelLeft, right: labelRight } = textLabel.getBoundingClientRect();const isVisible = (labelLeft > areaLeft && labelRight > areaLeft) && labelRight < areaRight;
			 	// 	label.setAttribute('style', `opacity: ${ isVisible ? 1 : 0}`);
			 	// }
			 	if (!labels) return;
			 	for (let i = 0; i < labels.length; i++) {
			 		const label = labels[i];
			 		const textLabel = label.getElementsByTagName('span')[0];
			 		const { left: areaLeft, right: areaRight } = area.getBoundingClientRect();
			 		const { left: labelLeft, right: labelRight } = textLabel.getBoundingClientRect();
			 		const isVisible = (labelLeft > areaLeft && labelRight > areaLeft) && labelRight < areaRight;
			 		label.setAttribute('style', `opacity: ${ isVisible ? 1 : 0}`);
			 	}
			 };

			 useEffect(() => {
			 	setInterval(() => {
			 		hideLabels();
			 	}, 250);
			 }, [currentWeight]);

			 return (
			 	<div style={{
			 		display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'
			 	}}>
			 		<div className="extraWhite-space" />
			 		<div className='progress-container image-container2'>
			 			<div className='image-wrapper' style={{ marginLeft: progressCapped ? `${95}%` : `${currentWeight/2}%` }}>

			 				<div className='image-holder'>
			 					<img src={soccerball} alt="Gratis wk-voetballen" style={{ rotate: `calc(${currentWeight*Math.PI}rad / var(--ball-size))` }} />
			 				</div>
							    <div className={`free-balls-info${currentWeight > 160 ? ' free-balls-info--right' : ''}${locale === 'fr' && currentWeight > 160 ? ' free-balls-info-fr' : ''}`}>
			 					<div>{t.krijgt}</div>
			 					<div className="free-balls-count">{balls} {t.gratis}</div>
			 					<div style={{ fontSize: '1.4em' }}>{t.ballen}</div>
			 				</div>
			 			</div>
			 		</div>
			 		<div className="progress-container" >

			 			<div className="progress-bar">
			 				<div
			 					className="progress-fill"
			 					style={{ width: `${progressCapped ? 95 : progress}%` }}
			 				></div>
			 			</div>
			 			<div className="progress-labels" style={{ transform: `translateX(${progressCapped ? (190-currentWeight)/2 : 0}%)` }}>
			 				{/* <span>{minWeight} kg</span>
				<span>{maxWeight} kg</span> */}
			 				{milestones.map((m, i) => (
			 					<div
			 						key={m}
			 						className="milestone"
			 						// style={{ marginRight: i === milestones.length - 1 ? `${currentWeight % 40/40 *20 }%`: 0 }}

			 						// style={{ marginRight: i === milestones.length - 1 ? (progressCapped ? `${currentWeight % 40/40 *20 }%` : '0%') : '0%' }}
			 					><span>
			 							{m}kg
			 						</span>

			 						{/* <div className="milestone-dot">{milestones}</div>
						<span className="milestone-label">{m} kge</span> */}
			 					</div>
			 				))}
			 			</div>
			 			<div className="progress-info" style={{ marginLeft: progressCapped ? `${95}%` : `${currentWeight/2}%` }}>
			 				{currentWeight} kg
			 			</div>



			 			{/* <div className="progress-info">
					<strong>Huidig gewicht:</strong> {currentWeight} kg
				</div> */}
			 		</div>
			   <div className="reward-info">
				   {t.nog} <span className="reward-remaining">{remainingKg} kg</span> {t.teGaan} <span className="reward-balls">{t.meerBallen} </span>{t.reward}
			   </div>
			 	</div>
			 );
};


export default ProgressBar;
